import {CloseOutlined} from '@ant-design/icons';
import {Button, DatePicker, Flex, Form, Select} from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import {useAdminUpdateOrderStatusMutation} from '../../../../gen/api/apis';
import {AdminOrderStatusType} from '../../../../gen/api/models';
import {useNotification} from '../../../../NotificationContext';

export interface ProductOrderCreateProps {
    productId: string;
    orderId: string;
    onSuccess: () => void;
    onCancel: () => void;
}

interface Values {
    createdAt: string;
    orderStatus: AdminOrderStatusType;
}

export const ProductOrderAddStatus = (props: ProductOrderCreateProps) => {
    const notify = useNotification();
    const [form] = Form.useForm();

    const updateStatus = useAdminUpdateOrderStatusMutation({
        onSuccess: () => {
            notify.openNotificationWithIcon('success', 'Order status updated');
            props.onSuccess();
        },
        onError: (error) => {
            console.error(error);
            notify.openNotificationWithIcon('error', 'Error updating order status');
        },
    });

    const update = (values: Values) => {
        console.log('values', values);
        updateStatus.mutate({
            id: props.productId,
            orderId: props.orderId,
            params: {
                createdAt: values.createdAt,
                status: values.orderStatus,
            },
        });
    };

    return (
        <Form
            // layout="inline"
            form={form}
            name="updateStatus"
            clearOnDestroy
            onFinish={(values) => update(values)}
            size={'small'}
        >
            <Flex
                justify={'space-between'}
                gap={20}
            >
                <Flex gap={10}>
                    <Form.Item
                        name="orderStatus"
                        rules={[{required: true, message: ''}]}
                        noStyle
                    >
                        <Select
                            placeholder="Status"
                            allowClear
                            style={{width: 100}}
                            options={[
                                {label: 'Paid', value: AdminOrderStatusType.OrderStatusPaid},
                                {label: 'Canceled', value: AdminOrderStatusType.OrderStatusCanceled},
                                {label: 'Returned', value: AdminOrderStatusType.OrderStatusReturned},
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        name="createdAt"
                        rules={[{required: true, message: ''}]}
                        initialValue={dayjs()}
                        noStyle
                    >
                        <DatePicker
                            placeholder={'Date'}
                            showTime
                        />
                    </Form.Item>
                </Flex>
                <Flex gap={10}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={updateStatus.isLoading}
                    >
                        Update
                    </Button>
                    <Button
                        type="text"
                        loading={updateStatus.isLoading}
                        onClick={props.onCancel}
                        icon={<CloseOutlined />}
                    />
                </Flex>
            </Flex>
        </Form>
    );
};
